// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Ga6a7","overflowing":"ReadFullNote_overflowing__pHyQd"};